import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  MatButtonModule, MatCheckboxModule, MatIconModule, MatListModule, MatMenuModule,
  MatSidenavModule
} from '@angular/material';
import {RouterModule} from '@angular/router';
import {ThemePickerModule} from './theme-picker';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {LangPickerModule} from './lang-picker/lang-picker.module';
import {LogHelperService} from './log-helper/log-helper.service';
import {FormsModule} from '@angular/forms';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MatButtonModule,
    MatMenuModule,
    MatCheckboxModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    ThemePickerModule,
    LangPickerModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
  ],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MatButtonModule,
    MatMenuModule,
    MatCheckboxModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    ThemePickerModule,
    LangPickerModule,
    HttpClientModule,
    TranslateModule
  ],
  providers: [
    LogHelperService
  ],
  declarations: []
})
export class SharedModule {
}



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/shared/shared.module.ts